export default __webpack_public_path__ + "static/media/stakelogic.bacc4cc9.svg";